import React from 'react';

import './ResultsRefinements.scss';

import { useCurrentRefinements, useClearRefinements, useHitsPerPage, SearchBox, SortBy } from 'react-instantsearch-hooks-web';
import { ResultsFiltering } from "../ResultsFiltering/ResultsFiltering";

function CustomClearRefinements(props) {
    const { refine, canRefine, createURL } = useClearRefinements(props);

    return <button className="results-refinements-list-clear" onClick={() => refine()}>Clear All</button>;
}

function CustomCurrentRefinements(props) {
    const { items, canRefine, refine } = useCurrentRefinements(props);
    const defaultRefinements = props.defaultRefinements;
    const checkedRefinements = Object.values( defaultRefinements ).flat();

    const filteredItems = items.filter( ( i ) => {
        if(i.label !== 'visible' && i.label !== 'post_status' && i.label !== '_exclude_from_search' ) {
            return true;
        }
        return false;
    });

    let totalRefinements = 0;
    filteredItems.forEach( item => totalRefinements += item.refinements.length );

    const showClear = (totalRefinements - checkedRefinements.length) > 1;

    return (
        filteredItems.length > 0 &&
        <div className="results-refinements-list">
            {
                filteredItems.map( (item, i) => {
                    {
                        return (
                            item.refinements.map( (ref, r ) => {

                                return (
                                    <div className="results-refinements-list-item" key={r}>
                                        <button
                                            className="results-refinements-list-item-button"
                                            onClick={() => refine(ref)}
                                            disabled={checkedRefinements.includes(ref.label)}
                                        >
                                            {ref.label}
                                        </button>
                                    </div>
                                )
                            } )
                        )
                    }
                } )
            }
            {showClear && <CustomClearRefinements />}
        </div>
    );
}

function CustomHitsPerPage(props) {
    const { items, refine } = useHitsPerPage(props);
    const { value } = items.find(({ isRefined }) => isRefined) || {};

    return (
        <div className="selectmenu">
            <select
                onChange={(event) => {
                    refine(Number(event.target.value));
                }}
                value={String(value)}
            >
                {items.map((item) => (
                    <option key={item.value} value={String(item.value)}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export class ResultsRefinements extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`results-header${ this.props.filteringIsOpen ? ' filter-open' : '' }`}>
                <ResultsFiltering hideFilterModal={this.props.hideFilterModal} {...this.props} />
                <div className="results-refinements">
                    <div className="container">
                        <div className="results-refinements-display">
                            <CustomCurrentRefinements {...this.props} />
                        </div>
                        {
                            /**
                             * Hide for now; client may want to bring back later
                             *
                             * <div className="results-refinements-toggle">
                             *      <button className="results-toggle-button" onClick={() => { this.props.toggleFiltering() }} type="button">Refine Results</button>
                             * </div>
                             */
                        }
                    </div>
                </div>
            </div>
        );
    }

}
